export default theme => ({
  styleBase: {
    whiteSpace: 'nowrap',
    ...theme.typography.body2
  },
  activeLink: {
    cursor: 'pointer',
    textDecoration: 'underline',
    color: theme.palette.text.secondary
  }
});
